/* eslint-disable */
// source: wsgateway/packets.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var users_models_pb = require('../users/models_pb.js');
goog.object.extend(proto, users_models_pb);
var rooms_models_pb = require('../rooms/models_pb.js');
goog.object.extend(proto, rooms_models_pb);
goog.exportSymbol('proto.wsgateway.api.v1.EventChatMessagePacket', null, global);
goog.exportSymbol('proto.wsgateway.api.v1.RoomChatMessagePacket', null, global);
goog.exportSymbol('proto.wsgateway.api.v1.UserChatMessagePacket', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wsgateway.api.v1.UserChatMessagePacket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wsgateway.api.v1.UserChatMessagePacket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wsgateway.api.v1.UserChatMessagePacket.displayName = 'proto.wsgateway.api.v1.UserChatMessagePacket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wsgateway.api.v1.RoomChatMessagePacket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wsgateway.api.v1.RoomChatMessagePacket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wsgateway.api.v1.RoomChatMessagePacket.displayName = 'proto.wsgateway.api.v1.RoomChatMessagePacket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wsgateway.api.v1.EventChatMessagePacket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wsgateway.api.v1.EventChatMessagePacket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wsgateway.api.v1.EventChatMessagePacket.displayName = 'proto.wsgateway.api.v1.EventChatMessagePacket';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.toObject = function(opt_includeInstance) {
  return proto.wsgateway.api.v1.UserChatMessagePacket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wsgateway.api.v1.UserChatMessagePacket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wsgateway.api.v1.UserChatMessagePacket.toObject = function(includeInstance, msg) {
  var f, obj = {
fid: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: (f = msg.getMessage()) && users_models_pb.ChatMessageInfo.toObject(includeInstance, f),
timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wsgateway.api.v1.UserChatMessagePacket}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wsgateway.api.v1.UserChatMessagePacket;
  return proto.wsgateway.api.v1.UserChatMessagePacket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wsgateway.api.v1.UserChatMessagePacket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wsgateway.api.v1.UserChatMessagePacket}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFid(value);
      break;
    case 2:
      var value = new users_models_pb.ChatMessageInfo;
      reader.readMessage(value,users_models_pb.ChatMessageInfo.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wsgateway.api.v1.UserChatMessagePacket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wsgateway.api.v1.UserChatMessagePacket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wsgateway.api.v1.UserChatMessagePacket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      users_models_pb.ChatMessageInfo.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string fid = 1;
 * @return {string}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.getFid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wsgateway.api.v1.UserChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.setFid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional users.api.v1.ChatMessageInfo message = 2;
 * @return {?proto.users.api.v1.ChatMessageInfo}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.getMessage = function() {
  return /** @type{?proto.users.api.v1.ChatMessageInfo} */ (
    jspb.Message.getWrapperField(this, users_models_pb.ChatMessageInfo, 2));
};


/**
 * @param {?proto.users.api.v1.ChatMessageInfo|undefined} value
 * @return {!proto.wsgateway.api.v1.UserChatMessagePacket} returns this
*/
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wsgateway.api.v1.UserChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 timestamp = 3;
 * @return {number}
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.wsgateway.api.v1.UserChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.UserChatMessagePacket.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.toObject = function(opt_includeInstance) {
  return proto.wsgateway.api.v1.RoomChatMessagePacket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wsgateway.api.v1.RoomChatMessagePacket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.toObject = function(includeInstance, msg) {
  var f, obj = {
fid: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: (f = msg.getMessage()) && rooms_models_pb.ChatMessageInfo.toObject(includeInstance, f),
timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wsgateway.api.v1.RoomChatMessagePacket}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wsgateway.api.v1.RoomChatMessagePacket;
  return proto.wsgateway.api.v1.RoomChatMessagePacket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wsgateway.api.v1.RoomChatMessagePacket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wsgateway.api.v1.RoomChatMessagePacket}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFid(value);
      break;
    case 2:
      var value = new rooms_models_pb.ChatMessageInfo;
      reader.readMessage(value,rooms_models_pb.ChatMessageInfo.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wsgateway.api.v1.RoomChatMessagePacket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wsgateway.api.v1.RoomChatMessagePacket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      rooms_models_pb.ChatMessageInfo.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string fid = 1;
 * @return {string}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.getFid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wsgateway.api.v1.RoomChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.setFid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional rooms.api.v1.ChatMessageInfo message = 2;
 * @return {?proto.rooms.api.v1.ChatMessageInfo}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.getMessage = function() {
  return /** @type{?proto.rooms.api.v1.ChatMessageInfo} */ (
    jspb.Message.getWrapperField(this, rooms_models_pb.ChatMessageInfo, 2));
};


/**
 * @param {?proto.rooms.api.v1.ChatMessageInfo|undefined} value
 * @return {!proto.wsgateway.api.v1.RoomChatMessagePacket} returns this
*/
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wsgateway.api.v1.RoomChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 timestamp = 3;
 * @return {number}
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.wsgateway.api.v1.RoomChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.RoomChatMessagePacket.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.toObject = function(opt_includeInstance) {
  return proto.wsgateway.api.v1.EventChatMessagePacket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wsgateway.api.v1.EventChatMessagePacket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wsgateway.api.v1.EventChatMessagePacket.toObject = function(includeInstance, msg) {
  var f, obj = {
fid: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: (f = msg.getMessage()) && rooms_models_pb.ChatMessageInfo.toObject(includeInstance, f),
timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wsgateway.api.v1.EventChatMessagePacket}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wsgateway.api.v1.EventChatMessagePacket;
  return proto.wsgateway.api.v1.EventChatMessagePacket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wsgateway.api.v1.EventChatMessagePacket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wsgateway.api.v1.EventChatMessagePacket}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFid(value);
      break;
    case 2:
      var value = new rooms_models_pb.ChatMessageInfo;
      reader.readMessage(value,rooms_models_pb.ChatMessageInfo.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wsgateway.api.v1.EventChatMessagePacket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wsgateway.api.v1.EventChatMessagePacket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wsgateway.api.v1.EventChatMessagePacket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      rooms_models_pb.ChatMessageInfo.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string fid = 1;
 * @return {string}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.getFid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wsgateway.api.v1.EventChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.setFid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional rooms.api.v1.ChatMessageInfo message = 2;
 * @return {?proto.rooms.api.v1.ChatMessageInfo}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.getMessage = function() {
  return /** @type{?proto.rooms.api.v1.ChatMessageInfo} */ (
    jspb.Message.getWrapperField(this, rooms_models_pb.ChatMessageInfo, 2));
};


/**
 * @param {?proto.rooms.api.v1.ChatMessageInfo|undefined} value
 * @return {!proto.wsgateway.api.v1.EventChatMessagePacket} returns this
*/
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wsgateway.api.v1.EventChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 timestamp = 3;
 * @return {number}
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.wsgateway.api.v1.EventChatMessagePacket} returns this
 */
proto.wsgateway.api.v1.EventChatMessagePacket.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.wsgateway.api.v1);
